import React from "react";
import {ListActionButton} from "components/common";
import {ColumnsEdit} from "types/models/column-table-edit";
import {ColumnConfig} from "@ant-design/plots";

const manufacturerColumns: any = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    render: (text, record, index) => index + 1,
    width: "4%",
    align: "center",
  },
  {
    title: "Mã HSX",
    dataIndex: "id",
    key: "id",
    align: "left",
  },
  {
    title: "Tên HSX",
    dataIndex: "name",
    key: "name",
    align: "left",
  },
  {
    title: "Địa chỉ",
    dataIndex: "address",
    key: "address",
    align: "left",
  },
  {
    title: "Người đại diện",
    dataIndex: "representative",
    key: "representative",
    align: "left",
  },
  {
    title: "Điện thoại",
    dataIndex: "phone",
    key: "phone",
    align: "left",
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    align: "left",
  },
  {
    title: "Các nhóm mặt hàng",
    dataIndex: "commodityGroups",
    key: "commodityGroups",
    align: "left",
  },
  {
    title: "Trạng thái",
    dataIndex: "status",
    key: "status",
    align: "left",
    render(v, r, i) {
      return <>{v == 0 ? "Hoạt động" : "Dừng hoạt động"}</>;
    },
  },
  {
    title: "Ghi chú",
    dataIndex: "note",
    key: "note",
    show: true,
    align: "left",
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    key: "action",
    fixed: "right",
    width: 80,
  },
];

export {manufacturerColumns};
